'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var response = function response(ctx) {
  var params = ctx.req.params || {};
  var resp = ctx.res.data;

  // 统一登录态处理逻辑， 现阶段暂时使用返回值里面的处理后续会切换成header里的数据
  if (params.autoHandleSessionExpire && resp && resp.sessionExpired && resp.loginUrl) {
    if (window.confirm('登录超时，请重新登录')) {
      window.open(resp.loginUrl);
    }
  }

  return ctx;
};

exports.default = { response: response };